import { Component, EventEmitter, Input, isDevMode, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConsultantsService, IAccountCreation } from '../shared/services/consultants.service';
import { matchValidator } from './shared/validators/password.validator';
import { UserService } from 'src/shared/services/user/user.service';
import { User } from 'src/shared/models/user.class';

export interface Steps {
  label: string;
  color: string;
}

@Component({
  selector: 'seller-add-consultant',
  templateUrl: './seller-add-consultant.component.html',
  styleUrls: ['./seller-add-consultant.component.scss']
})
export class SellerAddConsultantComponent implements OnInit {
  @Input() asPublic = false;
   hide = true;
  @Output() accountCreated = new EventEmitter();
  public formConsultant: FormGroup;
  public loadingRequest: boolean;
  public steps: Steps[] = [
    { color: '#FF0000', label: 'A traiter' },
    { color: '#FFFF00', label: 'Attente CV' },
    { color: '#FFA500', label: 'En cours de qualification' },
    { color: '#F5FFFA', label: 'Convertie en ressource' },
    { color: '#228B22', label: 'Profil OK' },
    { color: '#2F4F4F', label: 'Profil KO' },
  ]

  public user: User
  selectedStep: any = { color: '#FF0000', label: 'A traiter' };

  constructor(private fb: FormBuilder, private consultantService: ConsultantsService, private snackBar: MatSnackBar, private router: Router, private userService: UserService) { }

  async ngOnInit() {
    this.formConsultant = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      firstName: [
        '',
        [
          Validators.pattern(/^[a-zA-Z -]+$/),
          Validators.minLength(2),
          Validators.required,
        ]
      ],
      lastName: [
        '',
        [
          Validators.pattern(/^[a-zA-Z -]+$/),
          Validators.minLength(2),
          Validators.required,
        ]
      ],
      addressCity: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ-Îî -']+$/)]],
      addressRegion: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ-Îî -']+$/)]],
      addressCountry: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ-Îî -']+$/)]],
      addressPostalCode: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]], // only accept 5 digits
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{10}$/) // checks for 10-digit integer
        ]
      ],
      password: [
        '',
        [
          Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/),
          Validators.minLength(8),
          Validators.required,
          matchValidator('confirmPassword', true)
        ]
      ],
      passwordConfirm: [
        '',
        [
          Validators.required,
          matchValidator('password')
        ]
      ],
      isExternal: [this.asPublic ? true : false, [Validators.required]],
      etape: [{}, [Validators.required]]
    });

    if (isDevMode()) {
      // this.formConsultant.setValue({
      // email: 'test@test.fr',
      // firstName: 'Mazen',
      // lastName: 'G.',
      // addressCity: 'Antibes',
      // addressRegion: 'Provence Alpes Côte d\'Azur',
      // addressCountry: 'France',
      // addressPostalCode: '06600',
      // phone: '0618391218',
      // password: 'motdepasse',
      // passwordConfirm: 'motdepasse'
      // });
    }
    if (this.userService.user) {
      this.user = this.userService.user;
    }
  }

  checkPasswords: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    let pass = group.get('password').value;
    let confirmPass = group.get('passwordConfirm').value
    return pass === confirmPass ? null : { notSame: true }
  }

  compareFn(f1: Steps, f2: Steps): boolean {
    return f1 && f2 ? f1.label.trim() === f2.label.trim() : f1 === f2;
  }

  public toggle(event) {
    this.formConsultant.controls.isExternal.setValue(event.checked);

  }

  public setEtape(value: any) {
    this.selectedStep = value.value

    //this.formConsultant.controls.etape.patchValue(value);
  }

  public async onSubmit() {
    this.loadingRequest = true;

    const data: IAccountCreation = {
      username: this.formConsultant.value.email,
      firstName: this.formConsultant.value.firstName,
      lastName: this.formConsultant.value.lastName,
      email: this.formConsultant.value.email,
      adress: {
        city: this.formConsultant.value.addressCity,
        region: this.formConsultant.value.addressRegion,
        country: this.formConsultant.value.addressCountry,
        postalCode: this.formConsultant.value.addressPostalCode
      },
      phone: this.formConsultant.value.phone,
      password: this.formConsultant.value.password,
      isExternal: this.formConsultant.value.isExternal,
      etape: this.selectedStep.label,
      responsable: this.user?._id
    };

    try {
      const result = await this.consultantService.createAccount(data);
      this.snackBar.open("Profil consultant créé avec succès ", null, {
        duration: 2000,
        panelClass: ['mat-snackbar-success']
      });

      if (this.asPublic) {
        this.accountCreated.emit(result);
      } else {
        this.router.navigate(['/home/seller-consultants']);
      }
    } catch (e) {
      this.snackBar.open("Une erreur est survenue", null, {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['danger-msg'],
        duration: 2000,
      });
    } finally {
      this.loadingRequest = false;
    }
  }
}